import useTimer from '../../utils/use-timer';

import styles from './count-down.module.css';

type CountDownProps = {
  expiryTimestamp: number;
  onExpire?: () => void;
};

export default function CountDown({
  expiryTimestamp,
  onExpire = () => {},
}: CountDownProps): JSX.Element {
  const { seconds, minutes } = useTimer({
    expiryTimestamp,
    onExpire: () => {
      onExpire();
    },
  });

  return (
    <span className={minutes < 1 ? styles.warning : styles.timer}>
      {minutes < 10 ? `(0${minutes}` : `(${minutes}`}:
      {seconds < 10 ? `0${seconds})` : `${seconds})`}
    </span>
  );
}
